import type { Routes } from '@angular/router';
import {
    CampaignFeature,
    createActionTriggerDealer,
    createMetaResolverWithDealer,
    HomeFeature,
    ModelsFeature,
    ngrxLoaderGuard,
    PageContentType,
    titleResolver,
} from '@hyundai/ng-common-lib';
import { vehicleProvider } from '@hyundai/vehicle-market-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import HomePageComponent from './home-page.component';

export default [
    {
        path: '',
        pathMatch: 'full',
        component: HomePageComponent,
        canActivate: [
            ngrxLoaderGuard({
                waitUntilLoadedSelector: HomeFeature.state.selectIsLoadingHome,
                dataToCheckSelector: HomeFeature.state.selectHome,
            }),
        ],
        providers: [
            provideState(CampaignFeature.state),
            provideEffects([CampaignFeature.effects]),
            provideState(ModelsFeature.state),
            provideEffects([ModelsFeature.effects]),
            provideState(HomeFeature.state),
            provideEffects([HomeFeature.effects]),
            createActionTriggerDealer(HomeFeature.actions.loadHome()),
            createActionTriggerDealer(ModelsFeature.actions.loadModelList(), (dealer) => dealer.hasSales),
            vehicleProvider,
        ],
        title: titleResolver((dealer) => `Ihr Hyundai Händler in ${dealer.city} | ${dealer.name}`),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Entdecken Sie Hyundai bei ${dealer.name} ${dealer.city}. Besuchen Sie uns jetzt und vereinbaren Ihre Probefahrt!`,
                };
            }),
        },
        data: {
            contentType: PageContentType.HOME,
        },
    },
] satisfies Routes;
